module.exports = __webpack_public_path__ + "img/file_1.7bf6c06.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/advancedVersion/file_1.png
// module id = OcYd
// module chunks = 0 2 3 7 12 13 14 17 26 28 32 34 52